import { apiService } from '@api';

const STORE_NAME = 'attractions';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        list: [],
        totalCount: 0,
        loading: false,
        selectedAttractions: [],
        params: {},
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTotalCount(state, totalCount) {
            state.totalCount = totalCount;
        },
        appendPageToList(state, pageData) {
            state.list = [...state.list, ...pageData];
        },
        setList(state, list) {
            state.list = list;
        },
        setSelectedAttractions(state, selectedAttractions) {
            state.selectedAttractions = selectedAttractions;
        },
        setParams(state, params) {
            state.params = params;
        },
    },
    getters: {
        allAttractionsLoaded: (state) => state.list.length >= state.totalCount,
    },
    actions: {
        getAttractions: async ({ commit, state }, props = { limit: 100, offset: 0 }) => {
            commit('setLoading', true);

            const response = await apiService.attractions.get({ ...state.params, ...props });

            if (response.success) {
                const { list, totalCount } = response.data;
                totalCount && commit('setTotalCount', totalCount);
                commit(
                    'setList',
                    list.map((item) => {
                        return {
                            text: item.name,
                            value: item.id,
                        };
                    })
                );

                commit('setLoading', false);

                return list;
            }

            commit('setLoading', false);
        },
        getAttractionsByName: async (
            { commit },
            props = { limit: 100, offset: 0, keyword: '' }
        ) => {
            commit('setLoading', true);

            const response = await apiService.attractions.get(props);

            if (response.success) {
                const { list, totalCount } = response.data;
                totalCount && commit('setTotalCount', totalCount);
                commit(
                    'setList',
                    list.map((item) => {
                        return {
                            text: item.name,
                            value: item.id,
                        };
                    })
                );

                commit('setLoading', false);

                return list;
            }

            commit('setLoading', false);
        },
        handleAttractionsChange: ({ commit }, selectedAttractions) => {
            commit('setSelectedAttractions', selectedAttractions);
        },
        resetState({ commit }) {
            commit('setList', []);
            commit('setTotalCount', 0);
            commit('setLoading', false);
            commit('setSelectedAttractions', []);
        },
        setParams({ commit }, params) {
            commit('setParams', params);
        },
    },
};
